export default __webpack_public_path__ + "static/media/Banner3.7118918f.png";